<!-- Footer -->
<div class="sec-footer">
	<div class="sec-footer-left">
		<div class="portal-logo sec-footer-logo"><portal-brand-logo></portal-brand-logo></div>
		<span class="sec-footer-project">{{ project?.description || project?.project_no }}</span>
	</div>
	<div class="sec-footer-right">
		<div class="sec-footer-pm" *ngIf="contact?.pm_name">
			<span class="sec-footer-pm-name">{{ contact.pm_name }}</span>
			<span class="sec-footer-pm-role">{{ contact.pm_role }}</span>
		</div>
		<div class="sec-footer-contact" *ngIf="paymentDetails?.email || paymentDetails?.phone">
			<div class="sec-footer-contact-item" *ngIf="paymentDetails?.email">
				<a [href]="'mailto:' + paymentDetails.email">{{ paymentDetails.email }}</a>
			</div>
			<div class="sec-footer-contact-item" *ngIf="paymentDetails?.phone">
				<a [href]="'tel:' + paymentDetails.phone">{{ paymentDetails.phone }}</a>
			</div>
		</div>
	</div>
</div>
